import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import {appConstants} from "../_constants";
import Icon from "@material-ui/icons/NetworkCheck";
import { connect } from "react-redux";

class AppCircularProgress extends React.Component {
    render() {
        const {message} = this.props;
        return (
            <Card>
                <CardHeader color={this.props.setView === "regional" ? "regional" : "success"} stats icon>
                    <CardIcon color={this.props.setView === "regional" ? "regional" : "success"}>
                        <Icon />
                    </CardIcon>
                </CardHeader>
                <CardBody style={{textAlign: 'center'}}>
                    <CircularProgress size={60} thickness={6} color={`${appConstants.DANGER_COLOR}`}/>
                    <h5 style={{textAlign: 'center'}}>{(message) ? message : 'Fetching data...'}</h5>
                </CardBody>
            </Card>
        );
    }
}

function mapStateToProps(state) {
  const {setView} = state;
  return {
    setView
  };
}

export default connect(mapStateToProps)(AppCircularProgress);



// WEBPACK FOOTER //
// ./src/utils/CircularProgress.js